/** @format */

/**
 * Hue → design-token bridge, shared by the typed-cell registry AND the
 * OptionPicker so a status/priority/type option renders the SAME colour in the
 * cell chip and in the dropdown list. `green/amber/red/blue` reuse the existing
 * success/warning/destructive/info tokens; `violet/cyan/pink` use the tokens
 * added for the registry; `gray` uses muted. No raw hex.
 */
export type Hue = 'green' | 'amber' | 'red' | 'blue' | 'violet' | 'cyan' | 'pink' | 'gray';

export const HUE_TOKEN: Record<Hue, { bg: string; fg: string; dot: string }> = {
  green: { bg: 'bg-success-light', fg: 'text-success-fg', dot: 'bg-success' },
  amber: { bg: 'bg-warning-light', fg: 'text-warning-fg', dot: 'bg-warning' },
  red: { bg: 'bg-destructive-light', fg: 'text-destructive-fg', dot: 'bg-destructive' },
  blue: { bg: 'bg-info-light', fg: 'text-info-fg', dot: 'bg-info' },
  violet: { bg: 'bg-violet-light', fg: 'text-violet-fg', dot: 'bg-violet' },
  cyan: { bg: 'bg-cyan-light', fg: 'text-cyan-fg', dot: 'bg-cyan' },
  pink: { bg: 'bg-pink-light', fg: 'text-pink-fg', dot: 'bg-pink' },
  // Reference `--gray-bg` (#f0f0f2) + `--gray-fg` (= --ink-2) + `--gray-dot`
  // (= --ink-3). Not `bg-muted` (the table re-scopes --muted to white).
  gray: {
    bg: 'bg-[rgb(var(--gray-bg))]',
    fg: 'text-[rgb(var(--ink-2))]',
    dot: 'bg-[rgb(var(--ink-3))]',
  },
};
